import { jsonProperty, Serializable } from "ts-serializable";

class VitalSignInstrument extends Serializable {
    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    nome: string | null = null;

    @jsonProperty(Boolean)
    padrao: boolean = false;
}

export default VitalSignInstrument;